<script>
  export let autor;
  export let registerAuthor;
  export let errorMsg;

  import { generateSign } from "../utils/revista.js";
  import { dictionary } from "../utils/stores.js";

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  let divErrorEmail;
  let divErrorNombre;
  let divErrorApellido1;
  let divErrorInstitucion;
  let divErrorFirma;
  let divErrorTerminos;

  let register = e => {
    const error =
      autor.email === "" ||
      autor.nombre === "" ||
      autor.apellido1 === "" ||
      autor.institucion === "" ||
      autor.firma === "" ||
      divErrorEmail.classList.contains("has-error") ||
      divErrorNombre.classList.contains("has-error") ||
      divErrorApellido1.classList.contains("has-error") ||
      divErrorInstitucion.classList.contains("has-error") ||
      divErrorFirma.classList.contains("has-error");
    if (!error) {
      e.preventDefault();
      if (autor.passwd1 !== autor.passwd2) {
        errorMsg = dict["errorPasswords"];
      } else {
        registerAuthor();
      }
    }
  };
</script>

<div id="createAuthor" class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{dict['nuevoAutor']}</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form
          class="rd-form rd-mailform"
          id="createAuthorForm"
          action=""
          method="post"
          on:submit={e => register(e)}>
          {#if errorMsg !== ''}
            <div class="alert alert-danger" role="alert">{errorMsg}</div>
          {/if}

          <div class="form-wrap" bind:this={divErrorEmail}>
            <input
              class="form-input"
              id="register-email"
              type="email"
              name="email"
              placeholder={dict['email']}
              data-constraints="@Email @Required"
              bind:value={autor.email} />
          </div>
          <div class="form-wrap" bind:this={divErrorNombre}>
            <input
              class="form-input"
              id="register-name"
              type="text"
              name="nombre"
              placeholder={dict['nombre']}
              data-constraints="@Required"
              bind:value={autor.nombre} />
          </div>
          <div class="form-wrap" bind:this={divErrorApellido1}>
            <input
              class="form-input"
              id="register-lastname1"
              type="text"
              name="apellido1"
              placeholder={dict['apellido1']}
              data-constraints="@Required"
              bind:value={autor.apellido1} />
          </div>
          <div class="form-wrap">
            <input
              class="form-input"
              id="register-lastname2"
              type="text"
              name="apellido2"
              placeholder={dict['apellido2']}
              bind:value={autor.apellido2} />
          </div>
          <div class="form-wrap" bind:this={divErrorInstitucion}>
            <input
              class="form-input"
              id="register-institution"
              type="text"
              name="institucion"
              placeholder={dict['institucion']}
              data-constraints="@Required"
              bind:value={autor.institucion} />
          </div>
          <div class="form-wrap" bind:this={divErrorFirma}>
            <input
              class="form-input"
              id="register-sign"
              type="text"
              name="firma"
              placeholder={dict['firma']}
              data-constraints="@Required"
              bind:value={autor.firma}
              on:focus={() => (autor.firma = generateSign(autor.nombre, autor.apellido1, autor.firma))} />
          </div>
          <div class="form-wrap">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                bind:checked={autor.seleccionableRevisor} />
              {dict['proponermeRevisor']}
            </label>
          </div>
          <div class="form-wrap" disabled={true}>
            <button
              class="button button-block button-primary button-shadow"
              type="submit">
              {dict['crearAutor']}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
